import { render, staticRenderFns } from "./AdminNeedResponse.vue?vue&type=template&id=6637c4a9&scoped=true&"
import script from "./adminNeedResponse.js?vue&type=script&lang=js&"
export * from "./adminNeedResponse.js?vue&type=script&lang=js&"
import style0 from "./AdminNeedResponse.vue?vue&type=style&index=0&id=6637c4a9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6637c4a9",
  null
  
)

export default component.exports